import { Text } from "lib/core/components/text"
import "./StepHeaderDescription.css"

const StepHeaderDescription = function ({ step }) {
  if (Text.isHTMLEmpty(step.description)) {
    return null
  } else {
    return (
      <Text
        className="StepHeaderDescription"
        html={step.description}
        interceptLink={true}
      />
    )
  }
}

StepHeaderDescription.displayName = "StepHeaderDescription"

export default StepHeaderDescription
